import React, { useCallback, useEffect, useState } from "react";

import moment from "moment";

import { addNotification, getAllAdminNews, getAllArticles, getMethodNames } from "services";

import { incomplete, useCancelAsyncOnUnmount, useNavigate, useTranslation } from "utils";

import { AdminHead, Button, Col, ErrorBoundary, Form, MainPage, Row, Message as message } from "components";

import { NotificationContent } from "pages/admin/users/components/NotificationContent";
import { NotificationSettings } from "pages/admin/users/components/NotificationSettings";
import { NotificationUserSegment } from "pages/admin/users/components/NotificationUserSegment";

export const NotificationAdd = () => {
  const { t } = useTranslation("enums");

  const [loading, setLoading] = useState(false);
  const [methods, setMethods] = useState([]);
  const [articles, setArticles] = useState([]);
  const [news, setNews] = useState([]);
  const [content, setContent] = useState("");
  const [type, setType] = useState("article");
  const [article, setArticle] = useState(null);
  const [sendDate, setSendDate] = useState(moment());
  const signal = useCancelAsyncOnUnmount()();
  const navigate = useNavigate();

  const loadAllNews = useCallback(() => {
    getAllAdminNews({
      signal,
    })
      .then((res) => {
        setNews(res.length > 0 ? res : []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  const loadAllArticles = useCallback(() => {
    getAllArticles({
      signal,
    }).then((res) => {
      setArticles(res.length > 0 ? res : []);
      loadAllNews();
    });
  }, [signal, loadAllNews]);

  const loadMethods = useCallback(() => {
    getMethodNames({
      signal,
    }).then((res) => {
      setMethods(res);
    });
  }, [signal]);

  const complete = (v) => {
    setLoading(true);

    addNotification({
      ...v,
      ...{
        content: content,
        sendDate: sendDate,
        article: article,
        signal,
      },
    })
      .then(() => {
        navigate("/users/notifications");
        message({
          content: "The gremlins accepted your sacrifice and will consume it! Nom nom nom",
          icon: "gremlin",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadMethods();
    loadAllArticles();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline="Add a notification"
        link="/users/notifications"
        tooltipText="Back to notifications"
        description={<>Send in-app and/or push notifications to users. A notification will only be sent to users who have enabled them.</>}
      />
      <Row className="midi-form">
        <Col>
          <Form name="confirm" onFinish={(v) => complete(v)} onFinishFailed={(v) => incomplete(v)}>
            <ErrorBoundary>
              <NotificationSettings setSendDate={setSendDate} setType={setType} />
            </ErrorBoundary>
            <ErrorBoundary>
              <NotificationUserSegment articles={articles} methods={methods} t={t} />
            </ErrorBoundary>
            <ErrorBoundary>
              <NotificationContent
                articles={articles}
                content={content}
                methods={methods}
                news={news}
                setArticle={setArticle}
                setContent={setContent}
                type={type}
              />
            </ErrorBoundary>
            <Row className="margin-top-200">
              <Col>
                <Form.Item>
                  <Button type="primary" htmlType="submit" disabled={loading} loading={loading} className="margin-right-100">
                    Save & schedule
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </MainPage>
  );
};
